const messages = {
    List : "Loading Services",
    bassApi : "Reading Baas API Key",
    regenerate : "Regenerate Baas API Key",
    checkNewService : "Creating new Service",
    createServiceError : 'Please enter valid name',
    updateService : "Updating Service",
}
export default messages;